export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: 1,
  minWidth: 0,
  height: '100%',
};

export const headerRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const subtitleStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  overflowY: 'auto',
};

export const emptyStateStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  color: ({ palette }) => palette.text.secondary,
};

export const footerRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '8px',
};
